import React, { Component } from 'react';
import { Box, Button, Card, Paragraph } from 'bumbag';
import _get from 'lodash/get';

import DataList from '@medipass/react-core/DataList';
import WithErrorMessage from '@medipass/react-core/WithErrorMessage';
import WithLoadingIndicator from '@medipass/react-core/WithLoadingIndicator';
import sdk from '@medipass/web-sdk';

import Page from 'components/account/layout/Page';
import TransactionList from 'components/account/transactions/TransactionsList';
import WithAuthentication from 'components/WithAuthentication';
import WithEmpty from 'components/WithEmpty';
type Props = {};
type State = {
  quotes: any;
};
export default class Quotes extends Component<Props, State> {
  getQuotes = async ({ page }: any = {}) => {
    const accountId = _get(sdk, 'account._id');
    const query = { transactionTypes: 'quote', limit: 10, sort: -1, page: page || 1 };
    const quotes = await sdk.accounts.getAccountTransactions(accountId, query);
    return { items: quotes.items, pageCount: quotes.meta.pageCount };
  };

  render() {
    return (
      <WithAuthentication>
        <Page minWidthBreakpoint="mobile" title="Quotes">
          <Card>
            <p className="font-semibold">Quotes</p>
            <Box data-testid="quotes-list">
              <DataList
                contextKey="quotes"
                loadData={this.getQuotes}
                loadMoreRenderer={({ loadMore, isLoading }) => (
                  <Box textAlign="center">
                    <Button palette="primary" variant="ghost" isLoading={isLoading} onClick={loadMore}>
                      Load more
                    </Button>
                  </Box>
                )}
                dataRenderer={({ items }) => (
                  <WithEmpty
                    iconName="far fa-receipt"
                    isActive={items.length === 0}
                    emptyText={
                      <Paragraph marginBottom="major-2" fontWeight="semibold" color="primary">
                        You do not have any quotes yet.
                      </Paragraph>
                    }
                  >
                    <TransactionList isQuote items={items} />
                  </WithEmpty>
                )}
                errorRenderer={({ error }) => (
                  <Box textAlign="center">
                    <WithErrorMessage isActive description="Unable to load your quotes" error={error} />
                  </Box>
                )}
                loadingRenderer={() => (
                  <Box textAlign="center">
                    <WithLoadingIndicator isActive />
                  </Box>
                )}
              />
            </Box>
          </Card>
        </Page>
      </WithAuthentication>
    );
  }
}
